module.exports = __webpack_public_path__ + "static/media/project1.f6c7c6c8.jpg";